export default "__VITE_ASSET__BgK8vBu0__"